import { RadioList, RadioListItem } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useVariantsSelector } from '../../../../state/SplitTests/selectors/useVariantsSelector';
import { useCallback, useState } from 'react';
import { useSetDefaultVariant } from '../../../../state/SplitTests/actions/useSetDefaultVariant';
import { useDefaultVariantSelector } from '../../../../state/SplitTests/selectors/useDefaultVariantSelector';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.designToken.spacing3};
`;
const Title = styled.div`
  font: ${({ theme }) => theme.designToken.body1};
  color: ${({ theme }) => theme.designToken.neutral900};
  margin-top: ${({ theme }) => theme.designToken.spacing4};
`;

export interface SchedulingDefaultVariantProps {
  splitTestId: string;
}

export const SchedulingDefaultVariant = ({ splitTestId }: SchedulingDefaultVariantProps) => {
  const { t } = useTranslation('campaigns');
  const variants = useVariantsSelector(splitTestId);
  const defaultVariant = useDefaultVariantSelector(splitTestId);
  const setDefaultVariant = useSetDefaultVariant();

  const [selectedDefaultOption, setSelectedDefaultOption] = useState<string>(defaultVariant?.messageId);

  const SetDefaultVariantOption = ({ messageId, name, onSelected, currentSelected }) => {
    const { t } = useTranslation('campaigns');

    const handleOnSelected = useCallback(() => {
      onSelected(messageId);
      setDefaultVariant({ id: splitTestId, variantMessageId: messageId });
    }, [onSelected, messageId]);

    const isSelected = currentSelected && currentSelected === messageId;

    return (
      <RadioListItem
        id={`radio-list-item-${messageId}`}
        onClick={handleOnSelected}
        selected={isSelected}
        aria-label={t('onsite.editor.workflow.displayWebContentMessage.scheduling.defaultVariant', {
          name: name,
        })}
        heading={t('onsite.editor.workflow.displayWebContentMessage.scheduling.defaultVariant', {
          name: name,
        })}
      />
    );
  };

  return (
    <Container>
      <Title>{t('onsite.editor.workflow.displayWebContentMessage.scheduling.schedulingDefaultVariantTitle')}</Title>
      <RadioList compacted>
        {variants?.map(s => {
          return (
            <SetDefaultVariantOption
              key={s.messageId}
              messageId={s.messageId}
              name={s.name}
              onSelected={setSelectedDefaultOption}
              currentSelected={selectedDefaultOption}
            />
          );
        })}
      </RadioList>
    </Container>
  );
};
